export default __webpack_public_path__ + "static/urban_adventures-ad47abb93a7365c7c5695694febae732.png";